import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
export type GetBuyerCodeForAgentResponse = string[];

/**
 * バイヤー選択項目取得サービス
 * @export GetBuyerCodeForAgentService
 * @class GetBuyerCodeForAgentService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetBuyerCodeForAgentService extends PlessJsonResponderSub<GetBuyerCodeForAgentResponse> {
  private succeed: (data: any) => void;
  private fail: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetBuyerCodeForAgentService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param s
   * @param f
   * @memberof GetBuyerCodeForAgentService
   */
  execute(
    s: (data: any) => void = null,
    f: () => void = null
  ): void {
    this.succeed = s;
    this.fail = f;
    this.send('getBuyerCodeForAgent', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetBuyerCodeForAgentService
   */
  success(data: GetBuyerCodeForAgentResponse) {
    if (this.succeed) this.succeed(data);
  }

  /**
   * async/await 記述用
   *
   * @param model
   * @returns Promise<void>
   */
  public executeAsync(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.execute(
        () => resolve(),
        () => reject()
      );
    });
  }

  protected statusError(status: string, result: any) {
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}
